import {
  BehaviorSubject,
  catchError,
  delay,
  filter,
  from,
  mergeMap,
  Observable,
  of,
} from 'rxjs';
import { Dependencies } from '../../../../configurations/dependencies/dependencies.interface';
import { Action, AnyAction } from '../../../state/action.type';
import { AppState } from '../../../state/app.state';
import { signOut } from '../../../state/authentication/authentication.action';
import {
  retrieveUsersTotalPointsBySeason,
  retrieveUsersTotalPointsBySeasonFailure,
  retrieveUsersTotalPointsBySeasonSuccess,
} from '../../../state/userSeason/userSeason.action';
import {
  RetrieveUsersTotalPointsBySeason,
  RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON,
} from '../../../state/userSeason/userSeason.action.type';
import { DEFAULT_RETRY_DELAY } from '../../constants/retry.constant';
import {
  TokenExpiredError,
  TokenInvalidError,
} from '../../errors/authentication.error';
import { SeasonUsersTotalPoints } from '../../models/userSeason.model';
export const retrieveUsersTotalPointsBySeasonUsecase = (
  action$: Observable<Action>,
  _state$: BehaviorSubject<AppState>,
  dependencies: Dependencies,
): Observable<Action> =>
  action$.pipe(
    filter(
      (action: AnyAction): action is RetrieveUsersTotalPointsBySeason =>
        action.type === RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON,
    ),
    mergeMap((action: RetrieveUsersTotalPointsBySeason) =>
      from(
        dependencies.userSeasonGateway.retrieveUsersTotalPointsBySeason(
          action.payload.token,
          action.payload.seasonId,
          action.payload.limit,
        ),
      ).pipe(
        mergeMap((usersTotalPoints: SeasonUsersTotalPoints) => {
          console.log(
            'retrieveUsersTotalPointsBySeasonUsecase: Success usersTotalPoints is:',
            usersTotalPoints,
          );
          return [
            retrieveUsersTotalPointsBySeasonSuccess({
              usersTotalPoints,
            }),
          ];
        }),
        catchError((error: Error) => {
          console.warn(
            'retrieveUsersTotalPointsBySeasonUsecase failed:',
            error.message,
          );
          const remainingRetries = action.payload.retry
            ? action.payload.retry - 1
            : 0;
          if (remainingRetries) {
            return of(
              retrieveUsersTotalPointsBySeason({
                token: action.payload.token,
                seasonId: action.payload.seasonId,
                limit: action.payload.limit,
                retry: remainingRetries,
              }),
            ).pipe(delay(DEFAULT_RETRY_DELAY));
          }

          if (
            error instanceof TokenExpiredError ||
            error instanceof TokenInvalidError
          ) {
            return of(
              retrieveUsersTotalPointsBySeasonFailure(error.message),
              signOut(),
            );
          }

          return of(retrieveUsersTotalPointsBySeasonFailure(error.message));
        }),
      ),
    ),
  );
